import React, { useState } from "react";
import { Box, Typography, Paper, Button, Grid, TextField, InputAdornment} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { useKeycloak } from '@react-keycloak/web';
import ApiConfig from '../../../utils/services/apiConfig'
import { useNavigate } from "react-router-dom";
import { formatLocalDateTime } from '../../../utils/dateTime';
import { useMountEffect } from '../../../utils/hooks';

function RobotLivestreamManagement() {
  const [robotLivestreams, setRobotLivestreams] = useState([])
  const [searchText, setSearchText] = useState('');
  const [robotNames, setRobotNames] = useState({}); // Map robotTableId to RobotId
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const navigate = useNavigate();

  const getRobotLivestreams = () => {
    Promise.all([
      apiConfig.fetchAllRobotLivestreams(),
    ]).then(results => {
      const livestreams = results[0].RobotResponse;
      setRobotLivestreams(livestreams);

      // Fetch robot data for all unique robot IDs
      const uniqueRobotIds = [...new Set(livestreams.map(ls => ls.RobotTableId))];
      const robotPromises = uniqueRobotIds.map(robotId =>
        apiConfig.fetchRobotData(robotId).catch(error => {
          console.error(`Failed to fetch robot ${robotId}:`, error);
          return null;
        })
      );

      Promise.all(robotPromises).then(results => {
        const newRobotNames = {};
        results.forEach(result => {
          if (result && result.RobotResponse) {
            newRobotNames[result.RobotResponse.Id] = result.RobotResponse.RobotId;
          }
        });
        setRobotNames(newRobotNames);
      });
    }).catch(error => {
      console.error(error);
    });
  }

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const handleDeleteLivestream = (id) => {
    Promise.all([
      apiConfig.deleteLivestream(id),
    ]).then(results => {
      console.log(results[0])
      getRobotLivestreams()
    }).catch(error => {
      console.error(error);
    });
  }

  const filteredRows = robotLivestreams.filter((row) =>
    Object.values(row).some((value) =>
      value.toString().toLowerCase().includes(searchText)
    )
  );

  useMountEffect(() => {

    getRobotLivestreams()

    return () => {
    };

  }, []);

  const columns = [
    { field: "Id", headerName: "ID", flex: 0.1},
    { field: "RobotTableId", headerName: "Robot", flex: 0.1, renderCell: (params) => {
      const robotId = params.value;
      return robotNames[robotId] || 'Loading...';
    }},
    { field: "CameraPosition", headerName: "Camera Position", flex: 0.1 },
    { field: "Url", headerName: "Robot Livestream Url", flex: 0.3 },
    { field: "UpdatedAt", headerName: "Updated At", flex: 0.1, renderCell: (params) => formatLocalDateTime(params.value) },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.15,
      renderCell: (params) => {

        return (
          <Grid container spacing={1}>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <Button variant="contained" color="primary" onClick={() => navigate(`/managements/robot_livestream_management/${params.row.Id}`)}>
                Edit
              </Button>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <Button variant="contained" color="primary" onClick={() => {handleDeleteLivestream(params.row.Id)}}>
                Delete
              </Button>
            </Grid>
          </Grid>
        );
      },
    },
  ];

  return (
    <Box p={2} >
      <Box display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        sx={{
          flexDirection: {
            xs: 'column',
            sm: 'row',
          },
          gap: {
            xs: 2,
            sm: 0,
          },
        }}>
          <Button variant="contained" color="primary" onClick={() => navigate(`/managements/robot_livestream_management/create`)}>
            Create New Robot Camera
          </Button>
          <Typography variant="h4">Robot Cameras</Typography>
          <TextField
            variant="outlined"
            placeholder="Search robot cameras"
            onChange={handleSearch}
            value={searchText}
            sx={{
              width: {
                xs: '100%',
                sm: '300px',
              },
              backgroundColor: 'background.paper',
              borderRadius: '5px',
              '& .MuiOutlinedInput-root': {
                borderRadius: '5px',
                height: {
                  xs: '40px',
                  sm: '50px',
                },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      <Paper elevation={3} sx={{ height: "100%", width: "100%", mt: 2 }}>
        <DataGrid rows={filteredRows} columns={columns} pageSize={5} getRowId={(row) => row.Id} rowsPerPageOptions={[5]} />
      </Paper>
    </Box>
  )
}

export default RobotLivestreamManagement;
